import Select from 'react-select';
import './Selection.css';

export default function Selection({
	onChange,
	options,
	value,
	className,
	menuPlacement,
	placeholder,
	getOptionLabel,
	getOptionValue,
	isDisabled,
	error
}) {
	return (
		<div className="input_field_wrapper selection_field_wrapper">
			<Select
				options={options}
				onChange={onChange}
				value={value}
				placeholder={placeholder}
				className={`selection ${className ?? ''}`}
				classNamePrefix="selection"
                isSearchable={false}
				{...(menuPlacement && { menuPlacement })}
				{...(getOptionLabel && { getOptionLabel })}
				{...(getOptionValue && { getOptionValue })}
				{...(isDisabled && { isDisabled })}
			/>
			{error && <span className="input_error_text">{error}</span>}
		</div>
	);
}
